import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Dashboard from './page/dashboard';
import Users from './page/users';
import Plans from './page/plans';
import DisputePage from './page/dispute-transaction';
import Operators from './page/operators';
import LoginPage from './page/login';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import OrderInfo from './page/order-info';
import PlanSlap from './page/plan-slap';
import Provider from './page/provider';
import MyProfile from './page/my-profile';
import UserProfile from './page/user-profile';
import Ledger from './page/ledger';
import UserReport from './page/user-report';
import OrderDetails from './page/order-details';
import ProviderBalance from './page/provider-balance';
import Error_404 from './page/error_404';
import RechargeAPIConfiguration from './page/recharge-api-configuration';
import TopUsageUser from './page/top-user-usage';
import TopTopupUser from './page/top-user-topup';
import Banners from './page/banner';
import FlightTrainSubs from './page/subscription';
import LiveTransaction from './page/order-info-live';
import ReportSales from './page/report-sales';
import ReportProviders from './page/report-providers';
import ReportOperators from './page/report-operator';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/users" element={<Users />} />
      <Route path="/user-top-usage" element={<TopUsageUser />} />
      <Route path="/user-top-topup" element={<TopTopupUser />} />
      <Route path="/order-info" element={<OrderInfo />} />
      <Route path="/order-recharge-info" element={<OrderInfo />} />
      <Route path="/order-billpayment-info" element={<OrderInfo />} />
      <Route path="/order-topup-info" element={<OrderInfo />} />
      <Route path='/operators' element={<Operators />} />
      <Route path='/plan-slap' element={<PlanSlap />} />
      <Route path='/providers' element={<Provider />} />
      <Route path='/my-profile' element={<MyProfile />} />
      <Route path='/profile' element={<UserProfile />} />
      <Route path='/ledger' element={<Ledger />} />
      <Route path='/user-report' element={<UserReport />} />
      <Route path='/order-details' element={<OrderDetails />} />
      <Route path='/provider-balance' element={<ProviderBalance />} />
      <Route path="/plans" element={<Plans />} />
      <Route path="/dispute-transaction" element={<DisputePage />} />
      <Route path="/operator" element={<Operators />} />
      <Route path="/recharge-api-config" element={<RechargeAPIConfiguration />} />
      <Route path="/banner" element={<Banners />} />
      <Route path="/subscription" element={<FlightTrainSubs />} />
      <Route path="/order-info-live" element={<LiveTransaction />} />

       <Route path="/report-sales" element={<ReportSales />} />
       <Route path="/report-providers" element={<ReportProviders />} />
       <Route path="/report-operators" element={<ReportOperators />} />
      <Route path="*" element={<Error_404 />} />
    </Routes>
  </BrowserRouter>
);
reportWebVitals();
